import * as React from "react";

import IncorporationProcess from 'src/containers/3a Incorporation/3a';

export default () => {
  return <IncorporationProcess type="seed" paymentAmount={6200} />;
}